
//import { v4 as uuidv4 } from 'uuid';
//import isEmpty from 'lodash/isEmpty';
//import cloneDeep from 'lodash/cloneDeep';
//import isObject from 'lodash/isObject';
//import { Duration } from 'luxon';
import toNumber from 'lodash/toNumber';
import isNaN from 'lodash/isNaN';
import { 
    //FormatCurrencyHelper, 
    hasValueOrZero, 
    HumanizeDurationFromIsoHelper,
    FormatDateHelper,
    toNumberOrNull,
} from '../../js/filters-helpers';
import { 
    //agNumberParser, 
    agIsoDurationFormatter, 
    agNumberFormatter, 
    agDateFormatter,
    agNumberFixedDecimalParser,
} from '../../js/ag-grid-helpers';
import {
    dtUtils,
    toLuxonDateTime,
} from '../../js/filters-helpers';
import { parseDecimal } from '@/js/utils/numberUtils';


// Vendor Response Columns
// ---------------------------------------------------------------

// Reusable ag-grid formatters, getters, setters, etc. -- move these to separate file later for more reusability

const vcolReplyGetter = (params) => {  // standard GETTER for bid items on QuoteSheetReply
    let fieldKey = params.colDef.field;  // plainKey - something like 'price' -- WITHOUT 'enable_'
    return params.data ? params.data.bid[fieldKey] : '';
};
const vcolReplySetter = (params) => {  // standard SETTER for bid items on QuoteSheetReply
    // { oldValue, newValue, data, node, colDef, column, api, columnApi, context }
    // console.log('Hello from vcolReplySetter', params);
    // Implement validation here?  new values can come from multiple places: direct editor input, paste operations, dragHandle, etc...
    // for paste operations, you can define a 'parser' in grid-wide processCellFromClipboard - but if the value is not valid and not directly coercible to correct type, then what to do?
    //      to overcome this, we could use put another value parser here, or at least check type / validation here... if not valid, then don't set the value - still rely on parsers for heavy lifting, this validation could be more lightweight
    //      OR... just use a custom valueSetter on each col instead of this...  but we want to let this handle the structure, other function handle validation
    let fieldKey = params.colDef.field;  // field is based on plainKey - something like 'price' WITHOUT 'enable_
    // if ( some condition? )return false;  // if this row doesn't meet some condition, return false to discard the edit
    // should we use valueParser here???? same params structure?  because valueParser seems to not get called on paste, maybe other times...
    // use our custom valueSetterParser if you have one -- returns { value, isValid } - takes same params as you have here
    if (params.colDef.valueSetterParser) {  // valueSetterParser will be null if not set for a column below
        const { value, isValid } = params.colDef.valueSetterParser(params);
        if (isValid) {
            params.data.bid[fieldKey] = value;
            return true;
        } else {  // no update, return false
            console.log('Ignoring invalid value in setter:', params.newValue);  // params.newValue is the original incoming value, before going to our valueSetterParser
            return false;
        }
    }
    // if no valueSetterParser function for this col, handle things normally
    params.data.bid[fieldKey] = params.newValue;  // params.data is the object/data for this bid
    return true;  // return true to let ag-grid know we updated it, so it refreshes
};

const vcolSelectReplyGetter = (params) => {  // GETTER to use for SELECT / SINGLE-CHOICE fields -- validates that gotten value is one of the select choices
    let fieldKey = params.colDef.field;
    let value = params.data ? params.data.bid[fieldKey] : '';  // if no value, fallback to empty string... empty string should be correct for select/choices fields
    if (!hasValueOrZero(value)) return value;  // if we don't have value, don't bother checking choices, just return whatever the value was (null, undefined, '', etc.)
    // continuing on, assuming we have value
    let choices = params.colDef.validChoices;
    if (!choices || !Array.isArray(choices)) return value;  // if we don't have choices, or choices not array, just return value
    // continue on assuming we have valid choices array
    return choices.includes(value) ? value : '';  // return value if its a valid choice, otherwise empty string (or some other type?)  empty string should be correct for select/choices fields
}

const vcolSelectReplySetter = (params) => {  // SETTER to use for SELECT / SINGLE-CHOICE fields -- validates that newValue is one of the select choices
    let choices = params.colDef.validChoices;
    if (!!choices && choices.includes(params.newValue)) {
        let fieldKey = params.colDef.field;
        params.data.bid[fieldKey] = params.newValue;
        return true;
    } else {
        return false;
    }
}

// HELPERS FOR COUNTRY OF ORIGIN STUFF
// assumes you have various things in the ag grid context:  countryCodes, countryNames, countryNamesByCode, countryCodesByName
// we store the internal value as the 2-letter code, but we want to show the full name in the grid
// and in the agRichSelectCellEditor component, we use list of NAMES for better searching... then in valueSetter we convert back to code

const countryOfOriginReplyGetter = (params) => {  // GETTER for country_of_origin - return the CODE or '' if not found
    //console.log('Hello from countryOfOriginReplyGetter params', params);
    const fieldKey = params.colDef.field;  // should be 'country_of_origin'
    const rawValue = params.data ? params.data.bid[fieldKey] : '';
    const namesByCode = params.context.countryNamesByCode || {};
    const codesByNames = params.context.countryCodesByName || {};
    if (!rawValue) return rawValue;
    if (namesByCode[rawValue]) {
        // if in here, we have a code already 
        return rawValue;
    } else if (codesByNames[rawValue]) {
        // if in here, we have a name, convert to code
        return codesByNames[rawValue];
    } else {
        return '';
    }
};

const countryOfOriginFormatter = (params) => {  // FORMATTER for country_of_origin - return the NAME, from the code or full name or ''
    //console.log('Hello from countryOfOriginFormatter params', params);
    const namesByCode = params.context.countryNamesByCode || {};
    const probablyCode = params.value;  // in some cases it could be the name also... so if we don't find it in the namesByCode, just return the value if not empty string
    return namesByCode[probablyCode] || probablyCode || '';
};

const countryOfOriginReplySetter = (params) => {  // SETTER to use for country_of_origin -- FIND AND SET THE 2-LETTER CODE -- or '' if not found
    // NOTE: we may (likely) have the full name in here since that's what we use in the dropdown for better search/filtering
    //console.log('Hello from countryOfOriginReplySetter params', params);
    const namesByCode = params.context.countryNamesByCode || {};
    const codesByNames = params.context.countryCodesByName || {};
    const oldCode = params.oldValue;
    let newCode = '';  // default... 
    if (codesByNames[params.newValue]) {
        // if value is in codesByNames, then we have a NAME, use it to get code
        newCode = codesByNames[params.newValue];
    } else if (namesByCode[params.newValue]) {
        // if value is in codesByNames, then we have a CODE, use it directly!
        newCode = params.newValue;
    } else {
        newCode = '';  // if not found, set to empty string
    }
    if (newCode !== oldCode) {
        let fieldKey = params.colDef.field;
        params.data.bid[fieldKey] = newCode;
        return true;
    } else {
        return false;
    }
};

const countryOfOriginParser = (params) => {  // PARSER to use for country_of_origin
    // converts from incoming value (full name OR 2-letter code) -> the 2-letter code, or '' -- then setter takes over from there
    //console.log('Hello from countryOfOriginParser params', params);
    const emptyValue = '';  // the default
    const codesByName = params.context.countryCodesByName || {};
    const namesByCode = params.context.countryNamesByCode || {};
    const newVal = params.newValue;
    if (!newVal) return emptyValue;
    if (namesByCode[newVal]) {
        return newVal;  // if its a code, just return it
    } else if (codesByName[newVal]) {
        // if its a name, return the code
        return codesByName[newVal];
    } else {
        return emptyValue;  // if not found, return empty string
    }
};

const countryOfOriginCompareGridGetter = (params) => {  // GETTER for country_of_origin IN COMPARE GRID -- converts the code to the full name (we do this at GETTER level so it is used in export also)
    //console.log('Hello from countryOfOriginCompareGridGetter params', params);
    const fieldKey = params.colDef.field;
    let replyId = params.colDef.replyId;  // params.column.parent.groupId;
    const value = params.data?.bids?.[replyId] ? params.data.bids[replyId][fieldKey] : '';
    return value;
    // USE BELOW IF YOU WANT TO SHOW THE NAME INSTEAD OF THE CODE
    // if (!value) return value;
    // const namesByCode = params.context.countryNamesByCode || {};
    // return namesByCode[value] || '';
};

const countryOfOriginCompareGridTooltipGetter = (params) => {  // GETTER for TOOLTIP of country_of_origin IN COMPARE GRID
    // get the full name here -- in the cell we only show the code to save space, but tooltip shows full name
    const fieldKey = params.colDef.field;
    let replyId = params.colDef.replyId;  // params.column.parent.groupId;
    const value = params.data?.bids?.[replyId] ? params.data.bids[replyId][fieldKey] : '';
    if (!value) return value;
    const namesByCode = params.context.countryNamesByCode || {};
    return namesByCode[value] || '';
};



const fixedDecimalDigits = 4;  // use this in bidPriceParser AND replyGridBidPriceFormatter AND compareGridBidPriceFormatter
// we had bidPriceParser here, but replaced with agNumberFixedDecimalParser in other module

const genericBidPriceFormatter = function(amount, currencyCode) {
    // DRY generic version we use in multiple places below!
    // also export it to use in other grids, like for 'Price Analysis' columns in compare grid
    // keep all the 'config' stuff in here!

    // amount -- should be a Number 
    // currencyCode -- should be a 3-digit string like 'USD'

    // RETURNS: null if there is not enough info for a formatted value -- or a STRING - formatted currency amount

    // IMPORTANT - make sure your PARSER has toFixed() with correct number of digits for your backend
    //          - this only DISPLAYS the formatted value... don't let it HIDE invalid values!  (like too many digits)
    // also, do a check when first loading quote sheet to see if users browser supports all this (Intl, etc)
    // see MDN for details:  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString

    if (!currencyCode) return null;  // don't show a price if there's no currency
    // OLD:  return FormatCurrencyHelper(params.value, currencyCode);
    // UPDATES March 3 2022 - to allow more than 2 decimal digits, and force truncation or rounding to 4
    // we will stop using FormatCurrencyHelper -- that does more than we need, and keep it for its own purposes
    // SETTINGS / CONFIG - eventually move these 'settings' things to some other place
    // we are using Number.toLocaleString(locales, options);
    // you can also make an Intl number formatter, then use method on that to format
    // const myFormatter = new Intl.NumberFormat('en-US', opts);
    // const formattedNumber = myFormatter.format(number)
    const locale = undefined;  // can be 'en-US' or something else... using undefined will use host default (should)
    const formatOptions = {
        style: 'currency',  // options are 'currency', 'decimal', 'percent', 'unit'
        currency: currencyCode,  // 3 letter currency code
        currencyDisplay: 'symbol',  // 'symbol', 'narrowSymbol', 'code', 'name' -- see docs -- default is 'symbol'
        currencySign: 'standard',  // 'accounting' (parenths) or 'standard' (-) -- default is 'standard'
        // lots more options... signDisplay, notation, 
        // roundingMode -- many options... we should not use this... should use toFixed() in parser instead!
        minimumIntegerDigits: 1,  // default is 1... always want a leading 0 for decimals
        // minimumFractionDigits: 2,  // USE DEFAULTS - the default for currency formatting is the number of minor unit digits provided by the ISO 4217 currency code list (2 if the list doesn't provide that information).
        // for maximumFractionDigits we want to specifically allow up to 4 (or more if you increase backend digits)
        maximumFractionDigits: fixedDecimalDigits,  // the default for currency formatting is the larger of minimumFractionDigits and the number of minor unit digits provided by the ISO 4217 currency code list (2 if the list doesn't provide that information)
    };
    // PROCESS THE VALUE
    const rawValue = amount;  // for convenience...
    // CHECK SOME THINGS FIRST TO MAKE SURE WE HAVE A NUMBER
    if (!Number.isFinite(rawValue)) {  // be careful not to reject zero 0 here -- you want 0 amounts to pass through as valid values
        // zero will not get rejected here, but null, '' will get rejected
        return null;
    }
    // numValueRaw will be Number, but may have too many digits/decimal places
    let numPattern = /[^0-9.-]+/g;  // we may not need all this, as long as we are sure what we're getting in... but that will take more testing... updating this in a rush on March 3 2022 to fix a Nifco bug
    let valueIsNumber = typeof rawValue === 'number'
    let valueAsNumber = valueIsNumber ? rawValue : rawValue.replace(numPattern, '');  // string.replace() returns a new string... 
    var numValueRaw = Number.parseFloat(valueAsNumber);
    if (Number.isNaN(numValueRaw)) {
        return null;
    } else {
        return numValueRaw.toLocaleString(locale, formatOptions);
    }
};

// TODO - need to make these work for BOTH price and quoted_price, with different currencies (maybe different)

const replyGridBidPriceFormatter = function(params) {
    // USED ON QuoteSheetReply grid -- for vendors to fill out
    // then uses the generic helper function above, which we use in multiple places
    // params.value will be a number here - or null if empty 
    let currencyCode = params.data.bid.price_currency;  // for price field specifically, we can get from bid.price_currency -- ONLY WORKS FOR THIS DATA STRUCTURE
    if (!currencyCode) return null;  // don't show a price if there's no currency -- should you move this to getter instead?
    let amount = params.value;
    return genericBidPriceFormatter(amount, currencyCode);
};

const replyGridBidQuotedPriceFormatter = function(params) {
    // USED ON QuoteSheetReply grid -- for vendors to fill out
    // then uses the generic helper function above, which we use in multiple places
    // params.value will be a number here - or null if empty 
    let currencyCode = params.data.bid.quoted_price_currency;  // for price field specifically, we can get from bid.price_currency -- ONLY WORKS FOR THIS DATA STRUCTURE
    if (!currencyCode) return null;  // don't show a price if there's no currency -- should you move this to getter instead?
    let amount = params.value;
    return genericBidPriceFormatter(amount, currencyCode);
};

const subtotalReplyGridFormatter = function(params) {
    // used for the SUBTOTAL column, if you have one
    // gets currency from the price_currency so they match
    // we use this without a renderer -- this handles all the formatting/display/placeholder
    let currencyCode = params.data.bid.price_currency;  // for price field specifically, we can get from bid.price_currency -- ONLY WORKS FOR THIS DATA STRUCTURE
    if (!currencyCode) return null;  // don't show a price if there's no currency -- should you move this to getter instead?
    let amount = params.value;
    return hasValueOrZero(amount) ? genericBidPriceFormatter(amount, currencyCode) : '-';
};

const quotedSubtotalReplyGridFormatter = function(params) {
    // used for the SUBTOTAL column, if you have one
    // gets currency from the quoted_price_currency so they match
    // we use this without a renderer -- this handles all the formatting/display/placeholder
    let currencyCode = params.data.bid.quoted_price_currency;  // for price field specifically, we can get from bid.price_currency -- ONLY WORKS FOR THIS DATA STRUCTURE
    if (!currencyCode) return null;  // don't show a price if there's no currency -- should you move this to getter instead?
    let amount = params.value;
    return hasValueOrZero(amount) ? genericBidPriceFormatter(amount, currencyCode) : '-';
};

var ReplyGridBidPriceCellRenderer = function(params) {
    // similar to PriceCellRenderer, but specifially for Price Quotes from Vendors (different placeholder)
    // keep this agnostic to currency code so you can use it for price and quoted_price
    const placeholder = `Enter your price`;  // just use the currency code for generic version of this renderer
    return hasValueOrZero(toNumberOrNull(params.value)) ? params.valueFormatted : placeholder;
};  // must export this, then 'register' it in 'components' of gridOptions with lowercased first char -- specify it by using string name below (lowercased first char)

const ReplyGridQuotedPriceRenderer = function(params) {
    // shows the quoted_price and the price if they are different currencies - return an HTML string
    const placeholder = `Enter your price`;  // just use the currency code for generic version of this renderer
    const quotedPriceFormatted = hasValueOrZero(toNumberOrNull(params.value)) ? params.valueFormatted : placeholder;
    // TODO - add the normal price too - have access to rowData in params.data
    const quotedPriceCurrency = params.data.bid.quoted_price_currency;
    const priceCurrency = params.data.bid.price_currency;
    const currencyDifferent = priceCurrency !== quotedPriceCurrency;
    //const priceAmount = params.data.bid.price;
    //const priceFormatted = priceCurrency ? genericBidPriceFormatter(priceAmount, priceCurrency) : '';
    // CALCULATING IT HERE
    const priceConvertedFormatted = params.data.getConvertedPriceFormatted();  // this is a method on BidGridRow
    const priceOutput = currencyDifferent && priceConvertedFormatted ? `<div class="font-size-70 text-muted">= ${priceCurrency} ${priceConvertedFormatted}</div>` : '';
    const quotedPriceOutput = `<div class="">${quotedPriceFormatted}</div>`
    return `${quotedPriceOutput}${priceOutput}`;
};

// COMPARE GRID HELPERS

const compareGridBidPriceFormatter = function(params) {
    let replyId = params.column.parent.groupId;
    let price_amount = params.data?.bids?.[replyId] ? params.data.bids[replyId]['price'] : null;
    let price_currency = params.data?.bids?.[replyId] ? params.data.bids[replyId]['price_currency'] : '';
    return genericBidPriceFormatter(price_amount, price_currency);
};

const compareGridBidQuotedPriceFormatter = function(params) {
    let replyId = params.column.parent.groupId;
    let price_amount = params.data?.bids?.[replyId] ? params.data.bids[replyId]['quoted_price'] : null;
    let price_currency = params.data?.bids?.[replyId] ? params.data.bids[replyId]['quoted_price_currency'] : '';
    return genericBidPriceFormatter(price_amount, price_currency);
};

const compareGridSubtotalPriceFormatter = function(params) {
    let replyId = params.column.parent.groupId;
    let subtotal_amount = params.data?.bids?.[replyId] ? params.data.bids[replyId]['subtotal'] : null;
    // using currency from price_currency -- backend does not output separate currency for 'subtotal' (since its a calculated field, not a model field)
    let price_currency = params.data?.bids?.[replyId] ? params.data.bids[replyId]['price_currency'] : '';
    return genericBidPriceFormatter(subtotal_amount, price_currency);
};

const compareGridQuotedSubtotalPriceFormatter = function(params) {
    let replyId = params.column.parent.groupId;
    let subtotal_amount = params.data?.bids?.[replyId] ? params.data.bids[replyId]['quoted_subtotal'] : null;
    // using currency from price_currency -- backend does not output separate currency for 'subtotal' (since its a calculated field, not a model field)
    let price_currency = params.data?.bids?.[replyId] ? params.data.bids[replyId]['quoted_price_currency'] : '';
    return genericBidPriceFormatter(subtotal_amount, price_currency);
};

var CompareGridBidPriceCellRenderer = function(params) {  // supports multi-currency
    // params.data is instance of CompareGridRow here!
    // you can make this way more efficient if you need to...
    const replyId = params.column.parent.groupId;
    const bidObject = params.data?.bids?.[replyId];
    const isNobid = bidObject ? (bidObject.nobid === true) : false;  // if we have the bid object (should) and nobid is explicitly true, then its a nobid, otherwise not
    // no need for currency code placeholder for internal display
    const placeholder = isNobid ? 'No Bid' : '';  // just use the currency code for generic version of this renderer
    // console.log(`CompareGridBidPriceCellRenderer - params.value, then params.valueFormatted, then params.data`, params.value, params.valueFormatted, params.data);
    // show the quoted_currency also!  as a tooltip?  in the same cell?  we added it as separate col
    return hasValueOrZero(toNumberOrNull(params.value)) ? params.valueFormatted : placeholder;
};  // must export this, then 'register' it in 'components' of gridOptions with lowercased first char -- specify it by using string name below (lowercased first char)

// TODO - change this to quoted_price -- then make a read-only col for price, based on conversion, only shown if currencies are different
let vendorColsAll = [
    // the columns that the vendor needs to complete
    // eventually this will all come from backend, so everything is consolidated in one array of objects (labels, choices, etc.)
    // THESE SHOULD BE CLASS INSTANCES OF SOMETHING
    {
        //key: 'enable_price',  // phasing this out...
        enableKey: 'enable_price',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'price',  // used other places, such as QuoteSheetReplyBid
        label: 'Price',  // human-friendly label to show on front-end
        sort_order: 1,  // for sorting amongst other cols
        required: true,  // is this column required to be considered a valid response? (used to validate reply bids) this does it on a column level, not individual line level
        isUserOptional: true,  // deprecated...
        defaultShow: true,  // deprecated...
        placeholder: '$X.XX',  // ???
        choices: null,  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of validChoices for this cell (value before Formatter, after Parser)
        width: 70,  // optimal width in pixels?  not used, but keeping for legacy, in case you start using old version of QuoteSheetBuilder again
        builderGrid: {
            tooltip: 'Price Quote',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: true,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            tooltip: 'Use a dot (X.XX) as the decimal separator, if using decimal values.',  // if no value, then label will be used in tooltip
            type: 'rightAligned',  // can be a string, or array of col 'type's - rightAligned is a built-in type
            minWidth: 80,
            maxWidth: 150,
            showConditionalBackground: true,  // set to true to show difference cell backgrounds for empty, valid, etc.
            valueGetter: vcolReplyGetter,
            valueSetter: vcolReplySetter,
            alignment: 'right',  // text alignment in the cell & header -- options are 'left', 'center', 'right', or '' (if '', then whatever is standard continues... maybe you have something special in cellRenderer)
            cellRenderer: 'replyGridBidPriceCellRenderer',  //  // then export that component and register it in 'components' of gridOptions - string name (key) of the 'components' or 'frameworkComponents' to use as cellRenderer -- use empty string to use default - due to how we build things up from here, we cannot just put the function here
            cellRendererParams: null,  // params for cellRenderer component
            cellEditor: null,  // string name (key) of the built-in editor or frameworkComponents to use as cellEditor
            cellEditorParams: null,  // object of params to pass to cellEditor component -- maybe use context instead to pass options to cellEditor...
            singleClickEdit: false,
            valueFormatter: replyGridBidPriceFormatter,  // converts from stored value to displayed value
            // OLD valueParser: agNumberParser,  // converts from input value to stored value
            // updated March 3 2022 - dedicated one just for parsing prices here
            // valueParser: bidPriceParser,  // TURNING OFF - using valueSetterParser instead for ALL parsing (from editor and paste)
            /* NOT BEING USED YET, BUT COULD - valueIsValid: (parsedValue) => {
                // generic validator to use in other methods - return boolean - might get called on new/old values - don't set anything here
                // this should be the parsedValue in here -- so we're checking a narrower scope of things
                // this is NOT to be used for checking if an incoming value is parseable - we can allow more things there 
                // in this col we only allow null or an actual number
                return !isNaN(toNumber(parsedValue));
            }, */
            valueSetterParser: (valueSetterParams) => {
                // custom validation/parser method used in valueSetter - return { value (any), isValid (boolean) }
                // this is only called inside valueSetter -- our generic valueSetter handles putting data into correct structure, this handles parsing/validating the value
                // why? because in our parsers (esp. for pasting) if value is garbage, cannot be parsed to something meaningful, we have no way to reject it, so we need validator too, which works in valueSetter by returning false there -- this combines these things into same step
                // params here are same as in valueSetter - so we have access to old and new values { oldValue, newValue, data, node, colDef, column, api, columnApi, context }
                // MUST be able to pass in null/empty values to UNSET current value, or else it's never possible
                let isValid = true;
                let value;
                // for prices/numbers, we will only accept things that don't return NaN in _.toNumber -- null, '' both return 0 from that, which makes sense, but 'some_string' returns NaN
                // changed to use @international/number for parsing -- to accomodate european-style numbers (comma as decimal separator)
                const useLocalizedParsing = false;  // set to true to use localized parsing -- WHEN READY (added March 2025)
                // TODO - change the tooltip when you ochange to use localized parsing!
                const rawValue = valueSetterParams.newValue;  // this is the raw value coming in from the editor
                const parsedValue = useLocalizedParsing ? parseDecimal(rawValue) : toNumber(rawValue);
                if (isNaN(parsedValue)) {
                    // if new value cannot be coerced to a number, then ignore it - but DO NOT NECESSARILY USE THE RETURN VALUE FROM toNumber - because '' -> 0 -- but you don't want that... you want '' -> null
                    isValid = false;
                    value = null;  // doesn't matter actually
                } else {
                    // before we started using localized parsing, we did NOT call toNumber here, so we are purposely using the rawValue if not using localized parsing
                    value = useLocalizedParsing ? agNumberFixedDecimalParser(parsedValue, fixedDecimalDigits) : agNumberFixedDecimalParser(rawValue, fixedDecimalDigits);
                    isValid = true;
                }
                // originally I thought we should check oldValue for some things... if old value was valid, but new value is ambiguous, then don't change it... but I don't think that's necessary?
                return { value, isValid };
            },
        },
        compareGrid: {  // used in CompanyTodoCompareGrid ag-grid colDefs
            field: 'price',  // could just use 'priceFormatted' (works) but then raw value in the grid will not be a number, will be a formatted string - either don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: 'Price',  // if no value, then main label will be used
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            tooltip: 'The quoted price from vendor',  // if no value, then label will be used in tooltip
            type: ['priceCol', 'rightAligned'],  // we put lots of stuff like valueFormatter, cellClassRules, etc in 'priceCol' - type can be a string, or array of col 'type's - rightAligned is a built-in type
            minWidth: 80,
            maxWidth: 150,
            // TODO - make this dynamic based on colGroup?: valueGetter: vcolReplyGetter,
            //cellRenderer: 'priceCellRenderer',  // string name (key) of the frameworkComponents to use as cellRenderer -- use empty string to use default - due to how we build things up from here, we cannot just put the function here
            cellRenderer: 'compareGridBidPriceCellRenderer',  // then export that component and register it in 'components' of gridOptions
            cellRendererParams: null,  // params for cellRenderer component
            alignment: 'right',  // text alignment in the cell & header -- options are 'left', 'center', 'right', or '' (if '', then whatever is standard continues... maybe you have something special in cellRenderer)
            cellClass: [],
            /* cellClassRules: {
                'is-min-price': params => (params.value === params.data.minBidPrice) && params.data.hasMultipleValidPrices,
                'is-max-price': params => (params.value === params.data.maxBidPrice) && params.data.hasMultipleValidPrices,
            }, */
            valueFormatter: compareGridBidPriceFormatter,  // converts from stored value to displayed value
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Price',
            tdClass: '',  // can be array or string
            thClass: '',
            /* formatter: (value, key, item) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return value;
            }, */
        },
    },
    {
        enableKey: 'enable_subtotal',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'subtotal',  // used other places, such as QuoteSheetReplyBid
        label: 'Line Item Total',  // human-friendly label to show on front-end
        sort_order: 2,  // for sorting amongst other cols
        required: false,  // is this column required to be considered a valid response? (used to validate reply bids) this does it on a column level, not individual line level
        isUserOptional: true,  // deprecated...
        defaultShow: true,  // deprecated...
        placeholder: '$X.XX',  // ???
        choices: null,  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of validChoices for this cell (value before Formatter, after Parser)
        width: 70,  // optimal width in pixels?  not used, but keeping for legacy, in case you start using old version of QuoteSheetBuilder again
        builderGrid: {
            tooltip: 'Line Item Total',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: false,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            tooltip: 'Line item total',  // if no value, then label will be used in tooltip
            type: 'rightAligned',  // can be a string, or array of col 'type's - rightAligned is a built-in type
            minWidth: 80,
            maxWidth: 150,
            showConditionalBackground: false,  // set to true to show difference cell backgrounds for empty, valid, etc.
            valueGetter: (params) => {
                if (!params.data?.variant.enable_subtotal || params.data?.bid.nobid) {
                    // not all nodes have data -- because of grouping - and make sure this is enabled and not nobid by vendor
                    return null;
                }
                return params.data.calculatedSubtotal;  
                // moved all of this to a getter on BidGridRow
                //return hasValueOrZero(params.data.bid.price) ? ((params.data.variant.quantity ?? 1) * params.data.bid.price) : null;
            },
            editable: false,  // always make this not editable
            alignment: 'right',  // text alignment in the cell & header -- options are 'left', 'center', 'right', or '' (if '', then whatever is standard continues... maybe you have something special in cellRenderer)
            cellClass: 'cell-muted',  // can be array or string, or undefined
            cellRenderer: 'simplePlaceholderRenderer',  // using this to show placeholder, but also so it has inner element that can be hidden if nobid
            cellRendererParams: {
                placeholder: '-',
            },
            valueFormatter: subtotalReplyGridFormatter,  // converts from stored value to displayed value
        },
        compareGrid: {  // used in CompanyTodoCompareGrid ag-grid colDefs
            field: 'subtotal',  // could just use 'priceFormatted' (works) but then raw value in the grid will not be a number, will be a formatted string - either don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            tooltip: 'Total quoted price for this line',  // if no value, then label will be used in tooltip
            type: ['rightAligned'],  // no longer including priceCol -- as of 9/28/2022 all that's left on there is the cellClassRules for showing min/max prices, and we'll just show those on price col, not subtotal col (overly complex with no value)
            minWidth: 80,
            maxWidth: 150,
            // TODO - make this dynamic based on colGroup?: valueGetter: vcolReplyGetter,
            //cellRenderer: 'priceCellRenderer',  // string name (key) of the frameworkComponents to use as cellRenderer -- use empty string to use default - due to how we build things up from here, we cannot just put the function here
            cellRenderer: 'compareGridBidPriceCellRenderer',  // then export that component and register it in 'components' of gridOptions
            cellRendererParams: null,  // params for cellRenderer component
            alignment: 'right',  // text alignment in the cell & header -- options are 'left', 'center', 'right', or '' (if '', then whatever is standard continues... maybe you have something special in cellRenderer)
            cellClass: [],
            /* cellClassRules: {
                'is-min-price': params => (params.value === params.data.minBidPrice) && params.data.hasMultipleValidPrices,
                'is-max-price': params => (params.value === params.data.maxBidPrice) && params.data.hasMultipleValidPrices,
            }, */
            valueFormatter: compareGridSubtotalPriceFormatter,  // converts from stored value to displayed value
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Line Item Total',
            tdClass: '',  // can be array or string
            thClass: '',
            /* formatter: (value, key, item) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return value;
            }, */
        },
    },
    {
        //key: 'enable_price',  // phasing this out...
        enableKey: 'enable_quoted_price',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'quoted_price',  // used other places, such as QuoteSheetReplyBid
        label: 'Quoted Price',  // human-friendly label to show on front-end
        sort_order: 3,  // for sorting amongst other cols
        required: true,  // is this column required to be considered a valid response? (used to validate reply bids) this does it on a column level, not individual line level
        isUserOptional: true,  // deprecated...
        defaultShow: true,  // deprecated...
        placeholder: 'Your quoted price',  // ???
        choices: null,  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of validChoices for this cell (value before Formatter, after Parser)
        width: 70,  // optimal width in pixels?  not used, but keeping for legacy, in case you start using old version of QuoteSheetBuilder again
        builderGrid: {
            tooltip: 'Price Quote (Quoted Currency)',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: true,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            tooltip: 'Use a dot (X.XX) as the decimal separator, if using decimal values.',  // if no value, then label will be used in tooltip
            type: 'rightAligned',  // can be a string, or array of col 'type's - rightAligned is a built-in type
            minWidth: 80,
            maxWidth: 150,
            showConditionalBackground: true,  // set to true to show difference cell backgrounds for empty, valid, etc.
            valueGetter: vcolReplyGetter,
            valueSetter: vcolReplySetter,
            alignment: 'right',  // text alignment in the cell & header -- options are 'left', 'center', 'right', or '' (if '', then whatever is standard continues... maybe you have something special in cellRenderer)
            //cellRenderer: 'replyGridBidPriceCellRenderer',  // works with price or quoted_price  // then export that component and register it in 'components' of gridOptions - string name (key) of the 'components' or 'frameworkComponents' to use as cellRenderer -- use empty string to use default - due to how we build things up from here, we cannot just put the function here
            cellRenderer: 'replyGridQuotedPriceRenderer',  // can't just put a function here for some reason... gotta reference it and register the component
            cellRendererParams: null,  // params for cellRenderer component
            cellEditor: null,  // string name (key) of the built-in editor or frameworkComponents to use as cellEditor
            cellEditorParams: null,  // object of params to pass to cellEditor component -- maybe use context instead to pass options to cellEditor...
            singleClickEdit: false,
            valueFormatter: replyGridBidQuotedPriceFormatter,  // converts from stored value to displayed value
            // OLD valueParser: agNumberParser,  // converts from input value to stored value
            // updated March 3 2022 - dedicated one just for parsing prices here
            // valueParser: bidPriceParser,  // TURNING OFF - using valueSetterParser instead for ALL parsing (from editor and paste)
            /* NOT BEING USED YET, BUT COULD - valueIsValid: (parsedValue) => {
                // generic validator to use in other methods - return boolean - might get called on new/old values - don't set anything here
                // this should be the parsedValue in here -- so we're checking a narrower scope of things
                // this is NOT to be used for checking if an incoming value is parseable - we can allow more things there 
                // in this col we only allow null or an actual number
                return !isNaN(toNumber(parsedValue));
            }, */
            valueSetterParser: (valueSetterParams) => {
                // custom validation/parser method used in valueSetter - return { value (any), isValid (boolean) }
                // this is only called inside valueSetter -- our generic valueSetter handles putting data into correct structure, this handles parsing/validating the value
                // why? because in our parsers (esp. for pasting) if value is garbage, cannot be parsed to something meaningful, we have no way to reject it, so we need validator too, which works in valueSetter by returning false there -- this combines these things into same step
                // params here are same as in valueSetter - so we have access to old and new values { oldValue, newValue, data, node, colDef, column, api, columnApi, context }
                // MUST be able to pass in null/empty values to UNSET current value, or else it's never possible
                let isValid = true;
                let value;
                // for prices/numbers, we will only accept things that don't return NaN in _.toNumber -- null, '' both return 0 from that, which makes sense, but 'some_string' returns NaN
                // changed to use @international/number for parsing -- to accomodate european-style numbers (comma as decimal separator)
                const useLocalizedParsing = false;  // set to true to use localized parsing -- WHEN READY (added March 2025)
                // TODO - change the tooltip when you ochange to use localized parsing!
                const rawValue = valueSetterParams.newValue;  // this is the raw value coming in from the editor
                const parsedValue = useLocalizedParsing ? parseDecimal(rawValue) : toNumber(rawValue);
                if (isNaN(parsedValue)) {
                    // if new value cannot be coerced to a number, then ignore it - but DO NOT NECESSARILY USE THE RETURN VALUE FROM toNumber - because '' -> 0 -- but you don't want that... you want '' -> null
                    isValid = false;
                    value = null;  // doesn't matter actually
                } else {
                    // before we started using localized parsing, we did NOT call toNumber here, so we are purposely using the rawValue if not using localized parsing
                    value = useLocalizedParsing ? agNumberFixedDecimalParser(parsedValue, fixedDecimalDigits) : agNumberFixedDecimalParser(rawValue, fixedDecimalDigits);
                    isValid = true;
                }
                // originally I thought we should check oldValue for some things... if old value was valid, but new value is ambiguous, then don't change it... but I don't think that's necessary?
                return { value, isValid };
            },
        },
        compareGrid: {  // used in CompanyTodoCompareGrid ag-grid colDefs
            field: 'quoted_price',  // could just use 'priceFormatted' (works) but then raw value in the grid will not be a number, will be a formatted string - either don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            tooltip: 'The quoted price from vendor',  // if no value, then label will be used in tooltip
            type: ['priceCol', 'rightAligned'],  // we put lots of stuff like valueFormatter, cellClassRules, etc in 'priceCol' - type can be a string, or array of col 'type's - rightAligned is a built-in type
            minWidth: 80,
            maxWidth: 150,
            // TODO - make this dynamic based on colGroup?: valueGetter: vcolReplyGetter,
            //cellRenderer: 'priceCellRenderer',  // string name (key) of the frameworkComponents to use as cellRenderer -- use empty string to use default - due to how we build things up from here, we cannot just put the function here
            cellRenderer: 'compareGridBidPriceCellRenderer',  // works with price or quoted_price - then export that component and register it in 'components' of gridOptions
            cellRendererParams: null,  // params for cellRenderer component
            alignment: 'right',  // text alignment in the cell & header -- options are 'left', 'center', 'right', or '' (if '', then whatever is standard continues... maybe you have something special in cellRenderer)
            cellClass: [],
            /* cellClassRules: {
                'is-min-price': params => (params.value === params.data.minBidPrice) && params.data.hasMultipleValidPrices,
                'is-max-price': params => (params.value === params.data.maxBidPrice) && params.data.hasMultipleValidPrices,
            }, */
            valueFormatter: compareGridBidQuotedPriceFormatter,  // converts from stored value to displayed value
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Price (as quoted)',
            tdClass: '',  // can be array or string
            thClass: '',
            /* formatter: (value, key, item) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return value;
            }, */
        },
    },
    {
        enableKey: 'enable_quoted_subtotal',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'quoted_subtotal',  // used other places, such as QuoteSheetReplyBid
        label: 'Quoted Line Item Total',  // human-friendly label to show on front-end
        sort_order: 4,  // for sorting amongst other cols
        required: false,  // is this column required to be considered a valid response? (used to validate reply bids) this does it on a column level, not individual line level
        isUserOptional: true,  // deprecated...
        defaultShow: true,  // deprecated...
        placeholder: 'Subtotal',  // ???
        choices: null,  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of validChoices for this cell (value before Formatter, after Parser)
        width: 70,  // optimal width in pixels?  not used, but keeping for legacy, in case you start using old version of QuoteSheetBuilder again
        builderGrid: {
            tooltip: 'Line Item Total',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: false,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            tooltip: 'Line item total',  // if no value, then label will be used in tooltip
            type: 'rightAligned',  // can be a string, or array of col 'type's - rightAligned is a built-in type
            minWidth: 80,
            maxWidth: 150,
            showConditionalBackground: false,  // set to true to show difference cell backgrounds for empty, valid, etc.
            valueGetter: (params) => {
                if (!params.data?.variant.enable_quoted_subtotal || params.data?.bid.nobid) {
                    // not all nodes have data -- because of grouping - and make sure this is enabled and not nobid by vendor
                    return null;
                }
                return params.data.calculatedQuotedSubtotal;  
                // moved to a getter on BidGridRow
                //return hasValueOrZero(params.data.bid.quoted_price) ? ((params.data.variant.quantity ?? 1) * params.data.bid.quoted_price) : null;
            },
            editable: false,  // always make this not editable
            alignment: 'right',  // text alignment in the cell & header -- options are 'left', 'center', 'right', or '' (if '', then whatever is standard continues... maybe you have something special in cellRenderer)
            cellClass: 'cell-muted',  // can be array or string, or undefined
            cellRenderer: 'simplePlaceholderRenderer',  // using this to show placeholder, but also so it has inner element that can be hidden if nobid
            cellRendererParams: {
                placeholder: '-',
            },
            valueFormatter: quotedSubtotalReplyGridFormatter,  // converts from stored value to displayed value
        },
        compareGrid: {  // used in CompanyTodoCompareGrid ag-grid colDefs
            field: 'quoted_subtotal',  // could just use 'priceFormatted' (works) but then raw value in the grid will not be a number, will be a formatted string - either don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            tooltip: 'Total quoted price for this line',  // if no value, then label will be used in tooltip
            type: ['rightAligned'],  // no longer including priceCol -- as of 9/28/2022 all that's left on there is the cellClassRules for showing min/max prices, and we'll just show those on price col, not subtotal col (overly complex with no value)
            minWidth: 80,
            maxWidth: 150,
            // TODO - make this dynamic based on colGroup?: valueGetter: vcolReplyGetter,
            //cellRenderer: 'priceCellRenderer',  // string name (key) of the frameworkComponents to use as cellRenderer -- use empty string to use default - due to how we build things up from here, we cannot just put the function here
            cellRenderer: 'compareGridBidPriceCellRenderer',  // works with price or quoted_price - then export that component and register it in 'components' of gridOptions
            cellRendererParams: null,  // params for cellRenderer component
            alignment: 'right',  // text alignment in the cell & header -- options are 'left', 'center', 'right', or '' (if '', then whatever is standard continues... maybe you have something special in cellRenderer)
            cellClass: [],
            /* cellClassRules: {
                'is-min-price': params => (params.value === params.data.minBidPrice) && params.data.hasMultipleValidPrices,
                'is-max-price': params => (params.value === params.data.maxBidPrice) && params.data.hasMultipleValidPrices,
            }, */
            valueFormatter: compareGridQuotedSubtotalPriceFormatter,  // converts from stored value to displayed value
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Line Item Total (as quoted)',
            tdClass: '',  // can be array or string
            thClass: '',
            /* formatter: (value, key, item) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return value;
            }, */
        },
    },
    {
        //key: 'enable_moq',  // phasing this out...
        enableKey: 'enable_moq',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'moq',  // used other places, such as QuoteSheetReplyBid
        label: 'MOQ',
        sort_order: 3,  // for sorting amongst other cols
        required: true,
        isUserOptional: true,
        defaultShow: false,
        choices: null,  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of strings
        placeholder: '1',
        width: 70,
        builderGrid: {
            tooltip: 'Minimum Order Quantity',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: true,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            tooltip: 'Minimum Order Quantity',  // if no value, then label will be used in tooltip
            type: 'rightAligned',
            minWidth: 80,
            maxWidth: 150,
            showConditionalBackground: true, 
            valueGetter: vcolReplyGetter,
            valueSetter: vcolReplySetter,
            alignment: 'right',
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'MOQ (qty)',
            },  // params for cellRenderer component
            cellEditor: null,
            cellEditorParams: null,
            singleClickEdit: false,
            valueFormatter: agNumberFormatter,
            //valueParser: agNumberParser,  // REPLACED BY valueSetterParser - which is used inside valueSetter
            valueSetterParser: (valueSetterParams) => {
                // custom validation/parser method used in valueSetter - return { value (any), isValid (boolean) }
                // handles values coming from editor and/or paste operations
                // MUST be able to pass in null/empty values to UNSET current value, or else it's never possible
                let newValue = valueSetterParams.newValue;
                let isValid = true;
                let value;
                const allowedEmptyValues = [null, '', undefined];
                const emptyValue = null;
                if (allowedEmptyValues.includes(newValue)) {
                    isValid = true;
                    value = emptyValue;
                } else if (isNaN(toNumber(newValue))) {
                    // if its NOT one of our allowed empty values, and cannot be coerced to a number (returns NaN) then we IGNORE IT
                    isValid = false;  // ignore it - don't set it
                    value = null;  // doesn't matter actually
                } else {
                    value = toNumberOrNull(newValue);
                    isValid = true;
                }
                return { value, isValid };
            },
        },
        compareGrid: {  
            field: 'moq',  // don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            tooltip: 'Minimum Order Quantity',  // if no value, then label will be used in tooltip
            type: 'rightAligned',
            minWidth: 80,
            maxWidth: 150,
            //valueGetter: vcolReplyGetter,
            alignment: 'right',
            cellClass: [],
            //cellRenderer: 'simplePlaceholderRenderer',  // probably need a different one for internal compare grid... 
            //cellRendererParams: {
            //    placeholder: 'MOQ (qty)',
            //},  // params for cellRenderer component
            //valueFormatter: agNumberFormatter,
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'MOQ',
            tdClass: 'text-center',  // can be array or string
            thClass: 'text-center',
            formatter: (value) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return toNumberOrNull(value);
            },
        },
    },
    {
        //key: 'enable_leadtime',  // phasing this out...
        enableKey: 'enable_leadtime',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'leadtime',  // used other places, such as QuoteSheetReplyBid
        label: 'Lead Time',
        sort_order: 4,  // for sorting amongst other cols
        required: true,
        isUserOptional: true,
        defaultShow: false,
        placeholder: 'X weeks',
        choices: null,  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of strings
        width: 70,  // should be width in pixels 
        builderGrid: {
            tooltip: 'Lead Time',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: true,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            tooltip: 'Lead Time',  // if no value, then label will be used in tooltip
            type: '',
            minWidth: 120,
            maxWidth: 180,
            showConditionalBackground: true,  
            valueGetter: vcolReplyGetter,
            valueSetter: vcolReplySetter,
            alignment: 'center',
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Lead Time',
            },  // params for cellRenderer component
            cellEditor: 'leadTimeEditor',  // TODO - add duration component here, and figure out formatter, parser, etc
            cellEditorParams: null,
            singleClickEdit: false,
            valueFormatter: agIsoDurationFormatter,
            // valueParser: null,
            valueSetterParser: (valueSetterParams) => {
                // custom validation/parser method used in valueSetter - return { value (any), isValid (boolean) }
                // handles values coming from editor and/or paste operations
                // MUST be able to pass in null/empty values to UNSET current value, or else it's never possible
                // internal value here is ISO Duration string 'P5W'
                let newValue = valueSetterParams.newValue;
                let isValid = true;
                let value;
                const allowedEmptyValues = [null, '', undefined];
                const emptyValue = '';  // the 'unset' value
                if (allowedEmptyValues.includes(newValue)) {
                    isValid = true;
                    value = emptyValue;
                } else {
                    // check if we have an ISO duration string, OR if we can try parsing one
                    const maybeLuxonDuration = dtUtils.toLuxonDuration(newValue);
                    const isValidDuration = maybeLuxonDuration && maybeLuxonDuration.isValid;
                    if (isValidDuration) {
                        // if we could get a valid duration from it
                        isValid = true;
                        value = maybeLuxonDuration.toISO();  // internal value is the ISO duration string
                    } else {  // NOT VALID
                        value = emptyValue;
                        isValid = false;
                    }
                }
                return { value, isValid };
            },
        },
        compareGrid: {  
            field: 'leadtimeFormatted',  // don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            tooltip: 'Lead Time',  // if no value, then label will be used in tooltip
            type: '',
            minWidth: 80,
            maxWidth: 150,
            //valueGetter: vcolReplyGetter,
            alignment: 'center',
            cellClass: [],
            /* probably use different one for compare grid
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Lead Time',
            },  // params for cellRenderer component */
            //valueFormatter: agIsoDurationFormatter,
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Lead Time',
            tdClass: 'text-center',  // can be array or string
            thClass: 'text-center',
            formatter: (value) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return HumanizeDurationFromIsoHelper(value);
            },
        },
    },
    {
        //key: 'enable_deliverydate',  // phasing this out...
        enableKey: 'enable_deliverydate',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'deliverydate',  // used other places, such as QuoteSheetReplyBid
        label: 'Delivery Date',
        sort_order: 5,  // for sorting amongst other cols
        required: true,
        isUserOptional: true,
        defaultShow: false,
        placeholder: 'MM/DD/YYYY',
        choices: null,  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of strings
        width: 70,  // should be width in pixels 
        builderGrid: {
            tooltip: 'Delivery Date',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: true,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            tooltip: 'Your quoted delivery date',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 130,  // must be wide enough for long date strings
            maxWidth: 150,
            showConditionalBackground: true,
            valueGetter: vcolReplyGetter,
            valueSetter: vcolReplySetter,
            alignment: 'center',
            cellRenderer: 'vueDateButtonRenderer',  // this just renders the valueFormatted, does not do its own formatting
            cellRendererParams: {
                placeholder: 'Select...',
            },
            cellEditor: 'bootstrapVueDatePickerEditor', // 'bootstrapVueDatePickerEditor', or 'vueDatePickerEditor'  // TODO - change to use BootstrapVueDatePickerEditor to eliminate v-calendar component
            cellEditorParams: null,
            singleClickEdit: false,  // maybe false because we have a button to click on instead?
            valueFormatter: (params) => {
                // WARNING - must use Luxon here
                // value will just be ISO date string ('2022-09-22')
                // if you use normal JS Date(), timezone will get set to UTC automaticallly... then if you don't adjust to UTC when formatting, it will use local users timezone, so date may be different!
                // must either use Luxon (which doesn't assume UTC if tz is not set) or use .toLocaleDateString(undefined, { timeZone: 'UTC' })
                return FormatDateHelper(params.value);  // same as agDateFormatter
            },
            // valueParser: null,
            valueSetterParser: (valueSetterParams) => {
                // custom validation/parser method used in valueSetter - return { value (any), isValid (boolean) }
                // handles values coming from editor and/or paste operations
                // we'll try parsing incoming dates as many ways as possible.  
                // MUST be able to pass in null/empty values to UNSET current value, or else it's never possible
                // Internal value is YYYY-MM-DD format as a string.
                let newValue = valueSetterParams.newValue;
                let isValid = true;
                let value;
                const allowedEmptyValues = [null, '', undefined];
                const emptyValue = '';  // the 'unset' value
                if (allowedEmptyValues.includes(newValue)) {
                    isValid = true;
                    value = emptyValue;
                } else {
                    // check if we have an ISO duration string, OR if we can try parsing one
                    // TODO - allow parsing from normal Excel formats (10/25/22) and JS Date() objects
                    const maybeLuxonDateTime = toLuxonDateTime(newValue); //dtUtils.toLuxonDuration(valueSetterParams.newValue);
                    const isValidDateTime = maybeLuxonDateTime && maybeLuxonDateTime.isValid;
                    if (isValidDateTime) {
                        // if we could get a valid datetime from it
                        isValid = true;
                        value = maybeLuxonDateTime.toISODate();  // internal value is the ISO date string YYYY-MM-DD
                    } else {  // NOT VALID
                        value = emptyValue;
                        isValid = false;
                    }
                }
                return { value, isValid };
            },
        },
        compareGrid: {  
            field: 'deliverydate',  // don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            tooltip: 'Vendor quoted delivery date',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 80,  // must be wide enough for long date strings
            maxWidth: 150,
            //valueGetter: vcolReplyGetter,
            alignment: 'center',
            cellClass: [],
            valueFormatter: agDateFormatter,
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Delivery Date',
            tdClass: 'text-center',  // can be array or string
            thClass: 'text-center',
            formatter: (value) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return FormatDateHelper(value);
            },
        },
    },
    {
        enableKey: 'enable_country_of_origin',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'country_of_origin',  // used other places, such as QuoteSheetReplyBid
        label: 'Country of Origin',
        sort_order: 6,  // for sorting amongst other cols
        required: true,  // if enabled for a quotesheet, is this column required for a line/bid to be 'valid'?  should be here
        isUserOptional: true,  // deprecated...
        defaultShow: false,  // deprecated...
        placeholder: 'Select one...',
        choices: [],  // we overwrite this when building colDefs with country obj list from QuoteSheet
        width: 70,  // should be width in pixels 
        builderGrid: {
            tooltip: 'Original Country of Origin for this item',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: true,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            // NOTE: you add countryOfOriginCodes and countryOfOriginRefData to the grid context when you build the grid -- get ref values from there!
            label: '',  // if no value, then main label will be used
            tooltip: 'Original Country of Origin for this item',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 80,
            maxWidth: 150,
            showConditionalBackground: true, 
            valueGetter: countryOfOriginReplyGetter,  // vcolSelectReplyGetter,  // these are not needed (do not work) with refData, which is what we use for country codes
            valueSetter: countryOfOriginReplySetter,  // vcolSelectReplySetter,  // these are not needed (do not work) with refData, which is what we use for country codes
            // DOWNSIDE OF USING refData vs. explicit getter/setter - the agRichSelectEditor search searches on the values (codes) and NOT the labels... kinda annoying
            alignment: 'center',
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Select country...'
            },  // params for cellRenderer component
            cellEditor: 'agRichSelectCellEditor',  // other option:  'agSelectCellEditor' - but doesn't handle long text well
            cellEditorParams: {
                values: [],  // overwrite from choices when building colDefs - we are NOT using refData... using NAMES here for better experience in the search/filter of the dropdown (otherwise it filters based on the codes, which sucks)
                cellHeight: 30,  // normal is 20
            },
            // refData: {},  // USE THIS OR valueGetter/valueSetter - not both - overwrite this from choices when building colDefs - should be a {code: name, code: name, ...} object
            singleClickEdit: false,
            valueFormatter: countryOfOriginFormatter,
            valueParser: countryOfOriginParser,
        },
        compareGrid: {  
            field: 'country_of_origin',  // don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            tooltip: 'Original Country of Origin for this item',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 70,
            maxWidth: 120,
            //valueGetter: vcolSelectReplyGetter,  // TODO - might need to customize this to get value from country object
            alignment: 'center',
            cellClass: [],
            /* probably use different one for compare grid
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Select one...'
            },  // params for cellRenderer component
            */
            tooltipValueGetter: countryOfOriginCompareGridTooltipGetter,  // in compare grid, we only show the CODE (to save space) but show tooltip with the NAME
            valueGetter: countryOfOriginCompareGridGetter,  // does the job of formatter too... so we don't need that also
            // valueFormatter: countryOfOriginFormatter,  // TODO - might need to customize this to get value from country object - should be automatic if we use refData
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Country of Origin',
            tdClass: 'text-center',  // can be array or string
            thClass: 'text-center',
            formatter: (value, key, item) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                // item here is a QuoteSheetReplyBidLine object, the bid data is in item.bid
                return item?.bid?.country_of_origin_name || value; // you SHOULD have country_of_origin_name in the serialized value, but if not, just use the value
            },
        },
    },
    {
        //key: 'enable_shipterms',  // phasing this out...
        enableKey: 'enable_shipterms',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'shipterms',  // used other places, such as QuoteSheetReplyBid
        label: 'Shipping Terms',
        sort_order: 7,  // for sorting amongst other cols
        required: true,
        isUserOptional: true,
        defaultShow: false,
        placeholder: 'EXW',
        choices: ['EXW', 'FOB', 'CIF', 'DAP', 'DDP'],  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of strings
        width: 70,  // should be width in pixels 
        builderGrid: {
            tooltip: 'Shipping Terms',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: true,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            tooltip: 'Quoted shipping Terms',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 80,
            maxWidth: 150,
            showConditionalBackground: true, 
            valueGetter: vcolSelectReplyGetter,
            valueSetter: vcolSelectReplySetter,  // should not need valueSetterParser - this already ignores invalid choices
            alignment: 'left',
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Select one...'
            },  // params for cellRenderer component
            cellEditor: 'agRichSelectCellEditor',  // other option:  'agSelectCellEditor' - but doesn't handle long text well
            cellEditorParams: {
                values: [],  // overwrite from choices when building colDefs
                cellHeight: 30,  // normal is 20
            },
            singleClickEdit: false,
            valueFormatter: null,
            valueParser: null,
        },
        compareGrid: {  
            field: 'shipterms',  // don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            tooltip: 'Shipping Terms',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 80,
            maxWidth: 150,
            //valueGetter: vcolSelectReplyGetter,
            alignment: 'center',
            cellClass: [],
            /* probably use different one for compare grid
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Select one...'
            },  // params for cellRenderer component
            */
            valueFormatter: null,
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Shipping Terms',
            tdClass: 'text-center',  // can be array or string
            thClass: 'text-center',
            /* formatter: (value, key, item) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return value;
            }, */
        },
    },
    {
        //key: 'enable_payterms',  // phasing this out...
        enableKey: 'enable_payterms',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'payterms',  // used other places, such as QuoteSheetReplyBid
        label: 'Payment Terms',
        sort_order: 8,  // for sorting amongst other cols
        required: true,
        isUserOptional: true,
        defaultShow: false,
        placeholder: 'Net 30',
        choices: ['Prepay', 'Net 30 days', 'Net 60 days', 'Net 90 days'],
        width: 70,  // should be width in pixels 
        builderGrid: {
            tooltip: 'Payment Terms',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: true,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            tooltip: 'Quoted payment terms',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 80,
            maxWidth: 150,
            showConditionalBackground: true, 
            valueGetter: vcolSelectReplyGetter,
            valueSetter: vcolSelectReplySetter,  // should not need valueSetterParser - this already ignores invalid choices
            alignment: 'left',
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Select one...'
            },  // params for cellRenderer component
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: [],  // overwrite from choices when building colDefs
                cellHeight: 30,  // normal is 20
            },
            singleClickEdit: false,
            valueFormatter: null,
            valueParser: null,
        },
        compareGrid: { 
            field: 'payterms',  // don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            tooltip: 'Vendor quoted payment terms',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 80,
            maxWidth: 150,
            //valueGetter: vcolSelectReplyGetter,
            alignment: 'center',
            cellClass: [],
            /* probably use different one for compare grid
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Select one...'
            },  // params for cellRenderer component */
            //valueFormatter: null,
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Payment Terms',
            tdClass: 'text-center',  // can be array or string
            thClass: 'text-center',
            /* formatter: (value, key, item) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return value;
            }, */
        },
    },
    {
        //key: 'enable_comment',  // phasing this out...
        enableKey: 'enable_comment',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'comment',  // used other places, such as QuoteSheetReplyBid
        label: 'Comment',
        sort_order: 9,  // for sorting amongst other cols
        required: false,
        isUserOptional: true,
        defaultShow: false,
        placeholder: 'vendor comment',
        choices: null,  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of strings
        width: 70,  // should be width in pixels 
        builderGrid: {
            tooltip: 'Vendor Comment',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: false,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: '',  // if no value, then main label will be used
            tooltip: 'Any additional comment?',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 100,
            maxWidth: 200,
            showConditionalBackground: false, 
            valueGetter: vcolReplyGetter,
            valueSetter: vcolReplySetter,
            alignment: 'left',
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Comment (optional)'
            },  // params for cellRenderer component
            cellEditor: null,  // could use agLargeTextCellEditor but keep it simple for now
            cellEditorParams: null,
            singleClickEdit: false,
            valueFormatter: null,
            valueParser: null,  // replace with valueSetterParser???  just coerce everything to string?
            valueSetterParser: (valueSetterParams) => {
                // custom validation/parser method used in valueSetter - return { value (any), isValid (boolean) }
                // handles values coming from editor and/or paste operations
                // we'll just coerce things to strings here
                let newValue = valueSetterParams.newValue;
                let isValid = true;
                let value;
                const allowedEmptyValues = [null, '', undefined];
                const emptyValue = '';  // the 'unset' value
                if (allowedEmptyValues.includes(newValue)) {
                    isValid = true;
                    value = emptyValue;
                } else {
                    // otherwise just coerce to string for basic types, ignore 'object' types
                    const canCoerce = ['number', 'string'].includes(typeof newValue);
                    if (canCoerce) {
                        isValid = true;
                        value = String(newValue);  
                    } else {
                        // otherwise, we ignore the value, set isValid = false
                        isValid = false;
                        value = emptyValue;  // won't matter, won't get set
                    }
                }
                return { value, isValid };
            },
        },
        compareGrid: {  
            field: 'comment',  // don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            label: '',  // if no value, then main label will be used
            tooltip: 'Any additional comment?',  // if no value, then label will be used in tooltip
            type: '',  
            minWidth: 80,
            maxWidth: 200,
            //valueGetter: vcolReplyGetter,
            alignment: 'left',
            cellClass: [],
            /* probably use different one for compare grid
            cellRenderer: 'simplePlaceholderRenderer',
            cellRendererParams: {
                placeholder: 'Comment (optional)'
            },  // params for cellRenderer component */
            //valueFormatter: null,
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: false,
            label: 'Vendor Comment',
            tdClass: '',  // can be array or string
            thClass: '',
            /* formatter: (value, key, item) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return value;
            }, */
        },
    },
    {
        //key: 'enable_nobid',  // phasing this out...
        enableKey: 'enable_nobid',  // key / field name as used in QuoteSheet and QuoteSheetItemVariant
        plainKey: 'nobid',  // used other places, such as QuoteSheetReplyBid
        label: 'Allow No-Bid',
        sort_order: 100,  // for sorting amongst other cols
        required: false,  // DON'T ENABLE THIS... required doesn't make sense for boolean fields like this
        isUserOptional: true,
        defaultShow: false,
        placeholder: '',
        choices: [true, false],  // a standard key on all vendorCols objects, use null if N/A.  otherwise input array of strings
        width: 70,  // should be width in pixels 
        builderGrid: {
            tooltip: 'Allow vendor to no-bid?',
            alignment: 'center',
            headerClass: null, // should be null, or a single string... our col builder function takes this, combines with other things into array of classes
            atLeastOneRequired: false,  // should this col be included in the check for 'at least one vendor reponse data col'? validation check? -- should be true for everything except comment and nobid
        },
        replyGrid: {  // data used on ag-grid for the QuoteSheetReply (not the builder)
            label: 'No Bid',
            headerClass: 'ag-header-center',  // single string, or null
            tooltip: 'No-bid this line',
            type: '',  
            minWidth: 50,
            maxWidth: 80,
            showConditionalBackground: false, 
            valueGetter: vcolReplyGetter,
            valueSetter: vcolReplySetter,  // don't use vcolSelectReplyGetter/vcolSelectReplySetter here... those are setup to handle STRING values, not booleans
            alignment: 'center',
            cellRenderer: 'genericCheckboxCellRenderer',
            cellRendererParams: null,  // params for cellRenderer component
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
                values: [true, false],  // no need to put these in 'choices' key since they are not dynamic 
                // values should be in the format you want to store... (before valueFormatter, after valueParser... booleans)
            },
            singleClickEdit: false,  // false because we are using a renderer to show checkbox instead
            suppressPaste: true,  // to prevent problems pasting non-bool stuff into this col
            // IMPORTANT -- true = 'No Bid'  --- false = 'Will Bid' --- true, affirmitive means vendor submits a no-bid
            valueFormatter: (params) => {  // convert true/false to 'No-Bid' / 'Will Bid'
                if (params.value === true) {
                    return 'No Bid';
                } else {
                    return 'Will Bid';
                }
            },
            /* valueParser: (params) => {  // convert 'No-Bid' / 'Will Bid' to true/false
                if (params.newValue === 'No Bid') {
                    return true;
                } else {
                    return false;
                }
            }, */
            valueSetterParser: (valueSetterParams) => {
                // custom validation/parser method used in valueSetter - return { value (any), isValid (boolean) }
                // handles values coming from editor and/or paste operations
                // Must be able to handle true/false/'No Bid'/'Will Bid' - get rid of those 'No Bid' and 'Will Bid' strings???
                let newValue = valueSetterParams.newValue;
                let isValid = true;
                let value;
                // we treat this one differently than others, there is no 'empty' value - only some specific allowed values with one being default (false)
                // for anything not an allowed value, we just ignore it
                // internal value is always just true/false literal booleans
                const noBidTrueValues = ['No Bid', true];  // can add more... 'yes', etc...
                const noBidFalseValues = ['Will Bid', false];  // can add more... 'no', ...
                if (noBidTrueValues.includes(newValue)) {
                    isValid = true;
                    value = true;
                } else if (noBidFalseValues.includes(newValue)) {
                    isValid = true;
                    value = false;
                } else {
                    // if value passed in was not one of specifically allowed values, we IGNORE IT, isValid = false
                    isValid = false;
                    value = false;  // doesn't matter, won't get set
                }
                return { value, isValid };
            },
        },
        compareGrid: {  
            field: 'nobid',  // don't include this, or use empty string to default to plainKey - this is what's used to pull data from row data object
            hide: true,  // hide this -- if its a nobid we'll show it some other way
            label: 'No Bid',
            headerClass: 'ag-header-center',  // single string, or null
            tooltip: 'Did vendor no-bid?',
            type: '',  
            minWidth: 50,
            maxWidth: 80,
            //valueGetter: vcolReplyGetter,
            alignment: 'center',
            cellClass: [],
            // not for compare grid display... cellRenderer: 'genericCheckboxCellRenderer',
            // cellRendererParams: null,  // params for cellRenderer component
            // IMPORTANT -- true = 'No Bid'  --- false = 'Will Bid' --- true, affirmitive means vendor submits a no-bid
            /*valueFormatter: (params) => {  // convert true/false to 'No-Bid' / 'Will Bid'
                if (params.value === true) {
                    return 'No Bid';
                } else {
                    return 'Will Bid';
                }
            },*/
        },
        replyViewerGrid: {  // things used for internal view of submitted replies - using bsVue table 
            hide: true,
            label: 'No bid?',
            tdClass: ['text-muted', 'text-uppercase'],  // can be array or string
            thClass: '',
            formatter: (value) => {  // only do formatting here... if you need to get from nested data, do that in component where you fetch data, not here
                return value ? 'No Bid' : '';  // value will be a boolean
            },
        },
    },
]

export {
    vendorColsAll,
    genericBidPriceFormatter,
    ReplyGridBidPriceCellRenderer,  // agnostic to currency code - must register as component renderer
    ReplyGridQuotedPriceRenderer,  // just for quoted_price -- must register as component renderer
    CompareGridBidPriceCellRenderer,  // agnostic to currency code - must register as component renderer
}